"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotBlank = isNotBlank;
exports.isNotNull = isNotNull;
exports.isDefined = isDefined;
exports.isNotEmpty = isNotEmpty;
exports.isDefinedAndNotNull = isDefinedAndNotNull;
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * API FILTERS
 *
 * Utility classes for prepping filter parameters for the API
 */
function isNotBlank(value) {
  return value !== '';
}

function isNotNull(value) {
  return value !== null;
}

function isDefined(value) {
  return typeof value !== 'undefined';
}

function isNotEmpty(value) {
  return value && value.length > 0;
}

function isDefinedAndNotNull(value) {
  return isNotNull(value) && isDefined(value);
}

var ApiFilter = /*#__PURE__*/function () {
  /**
   * @param {string} key - The key to use for the query parameter in the query string.
   * @param {array[function]} validators - List of functions to use to check that the
   *                                       filter has a valid value. If not, it should
   *                                       not be included in query params.
   * @param {function} extractor - How to extract the filters value. Usually, this is
   *                               one-to-one, but sometimes (as in the case of arrays)
   *                               the value needs to be transformed.
   */
  function ApiFilter(key) {
    var validators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [isDefinedAndNotNull, isNotBlank];
    var extractor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (i) {
      return i;
    };

    _classCallCheck(this, ApiFilter);

    this.key = key;
    this.validators = validators;
    this.extractor = extractor;
  }

  _createClass(ApiFilter, [{
    key: "isValid",
    value: function isValid(value) {
      var valid = true;
      this.validators.forEach(function (v) {
        if (!v(value)) {
          valid = false;
        }
      });
      return valid;
    }
  }], [{
    key: "create",
    value: function create(_ref) {
      var key = _ref.key,
          validators = _ref.validators,
          extractor = _ref.extractor;
      return new ApiFilter(key, validators, extractor);
    }
  }, {
    key: "buildParams",
    value: function buildParams(filtersMap, filters) {
      var result = {};
      Object.keys(filters).forEach(function (key) {
        var value = filters[key];
        var filter = filtersMap[key];
        if (!filter) return;

        if (filter.isValid(value)) {
          result[filter.key] = filter.extractor(value);
        }
      });
      return result;
    }
  }]);

  return ApiFilter;
}();

exports["default"] = ApiFilter;

_defineProperty(ApiFilter, "validators", {
  isNotNull: isNotNull,
  isDefined: isDefined,
  isNotEmpty: isNotEmpty,
  isDefinedAndNotNull: isDefinedAndNotNull
});